


































































































































































































































































































































import { Component, Vue, namespace, Prop, Watch } from 'nuxt-property-decorator'
import { mdiInformationOutline, mdiChevronDown, mdiGiftOutline } from '@mdi/js'
import { VPopover } from 'v-tooltip'
import { IStyle } from '~/assets/interfaces/classes'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import {
  IProductAdditionalService,
  IProductToCart,
  IProductToFavourites,
} from '~/assets/interfaces/products'
import { ICartItem, ICartMessage } from '~/assets/interfaces/cart'
import { filterPrice } from '~/assets/filters/price'
import { filterBonus } from '~/assets/filters/bonus'
import { debounce } from '~/assets/functions/debounce'
import { ORDER_PATH } from '~/assets/config/path'
import { declension } from '~/assets/functions/declension'
import { filterUrl } from '~/assets/filters/url'
import {
  API_CART_DELAY,
  API_CART_DELETE,
  API_CART_SERVICE,
} from '~/assets/config/api-path'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentImage from '~/components/images/image.vue'
import ComponentPrice from '~/components/price/price.vue'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentOrderBuyOneClick from '~/components/products/buy-one-click.vue'
import ComponentFormCheckbox from '~/components/form/checkbox.vue'

const cartStore = namespace('cart')
const favouritesStore = namespace('favourites')
const siteStore = namespace('site')

@Component({
  components: {
    ComponentImage,
    ComponentPrice,
    ComponentFormButton,
    ComponentLoadingDots: () => import('~/components/loading/dots.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentOrderBuyOneClick,
    ComponentAlert: () => import('~/components/alerts/alert.vue'),
    ComponentFormCheckbox,
    ComponentIcon,
    VPopover,
  },
  filters: {
    filterPrice,
    filterBonus,
    filterQuantity(num: number) {
      return (
        num.toString() + ' ' + declension(num, ['товар', 'товара', 'товаров'])
      )
    },
  },
})
export default class ComponentMobileOrderCart extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isCanBuyOneClick!: boolean

  @cartStore.Action('getItems') private cartGetItems!: () => Promise<void>
  @siteStore.Getter('getOptionsCurrency') private getOptionsCurrency!: string
  @cartStore.Action('toCart') private toCart!: (
    product: IProductToCart
  ) => Promise<void>

  @cartStore.State('items') private cartItems!: ICartItem[]
  @cartStore.State('message') readonly message!: ICartMessage | null
  @cartStore.State('canOrder') readonly canOrder!: boolean
  @cartStore.State('bonus') readonly summaryBonus!: number
  @cartStore.State('isFirstLoaded') private isFirstLoaded!: boolean
  @favouritesStore.Action('toFavourites') private toFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  @cartStore.Getter('itemsQuantity') private itemsQuantity!: number
  @favouritesStore.Action('deleteFavourites') private deleteFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  @favouritesStore.State('items') private favouritesItems!: IFavouriteItem[]

  private $style!: IStyle
  private isShowBuyOneClick = false

  private newItems: ICartItem[] | null = null
  private isLoading = false
  private mdiInformationOutline = mdiInformationOutline
  private mdiChevronDown = mdiChevronDown
  private mdiGiftOutline = mdiGiftOutline

  private get checkAllProducts() {
    if (this.newItems) {
      let tempTrue = true
      this.newItems.forEach((item) => {
        tempTrue = tempTrue && item.active
      })
      return tempTrue
    }
    return false
  }

  private set checkAllProducts(val: boolean) {
    ;(async () => {
      await this.delay2({
        id: -1,
        active: val,
      })
    })()
  }

  @Watch('cartItems', { deep: true, immediate: true })
  private cartItemsHandler(val: ICartItem[]) {
    this.newItems = JSON.parse(JSON.stringify(val))
  }

  private async delay(item: ICartItem) {
    this.isLoading = true
    await this.delay2({
      id: item.cartId,
      active: item.active,
    })
    this.isLoading = false
  }

  private async delay2(item: { id: number; active: boolean }) {
    this.isLoading = true
    await this.$axios.$post(API_CART_DELAY, {
      id: item.id,
      active: item.active,
    })

    await this.cartGetItems()

    this.isLoading = false
  }

  private isInFavourites(id: number) {
    return !!this.favouritesItems.find((item) => {
      return item.id === id
    })
  }

  private toOrder() {
    this.$router.push(filterUrl(ORDER_PATH))
  }

  private toFavouritesText(id: number) {
    return this.isInFavourites(id) ? 'В избранном' : 'В избранное'
  }

  private mounted(): void {
    this.$emit('loaded')
  }

  private classToFavourites(id: number) {
    return {
      [this.$style.additionalActionsItem]: true,
      [this.$style.active]: this.isInFavourites(id),
    }
  }

  private get cartPrice() {
    let temp = 0
    this.activeCartItems.forEach((item) => {
      temp = temp + item.quantity * item.price
    })

    return temp
  }

  private changeQuantity(id: number, cartId: number, quantity: number) {
    this.changeQuantityDebounce(id, cartId, quantity, this)
  }

  private changeQuantityDebounce: (
    id: number,
    cartId: number,
    quantity: number,
    that: this
  ) => void = debounce(
    async (id: number, cartId: number, quantity: number, that: this) => {
      if (quantity.toString().trim().length !== 0) {
        that.isLoading = true
        await that.toCart({
          id: Number(id),
          cartId: Number(cartId),
          quantity: Number(quantity),
        })
        that.isLoading = false
      }
    },
    250
  )

  private get activeCartItems() {
    return this.cartItems.filter((item) => item.active)
  }

  private get activeItemsQuantity() {
    return this.activeCartItems.length
  }

  private get cartFinalPrice() {
    let temp = 0
    this.activeCartItems.forEach((item) => {
      temp = temp + item.quantity * item.finalPrice
    })

    temp = temp + this.cartPriceServices
    return temp
  }

  private async deleteItems() {
    this.isLoading = true
    await this.$axios.$post(API_CART_DELETE, {
      productId: -1,
    })
    await this.cartGetItems()
    this.isLoading = false
  }

  private get cartPriceServices() {
    let temp = 0
    this.activeCartServiceItems.forEach((item) => {
      temp = temp + item.price
    })

    return temp
  }

  private hiddenServices(item: ICartItem) {
    const index = this.hiddenServicesArray.indexOf(item.cartId)
    if (index >= 0) {
      this.hiddenServicesArray.splice(index, 1)
    } else {
      this.hiddenServicesArray.push(item.cartId)
    }
  }

  private getQuantityServices(items: IProductAdditionalService[]) {
    return items.filter((item) => item.active).length
  }

  private get servicePriceRender() {
    if (this.cartPriceServices === 0) {
      return 'Бесплатно'
    } else {
      return filterPrice(this.cartPriceServices) + this.getOptionsCurrency
    }
  }

  private hiddenServicesArray: number[] = []

  private IsInHiddenServicesArray(item: ICartItem) {
    return !this.hiddenServicesArray.includes(item.cartId)
  }

  private async checkServices(
    item: ICartItem,
    service: IProductAdditionalService
  ) {
    this.isLoading = true
    await this.checkServices2({
      id: item.cartId,
      service: {
        id: service.id,
        active: service.active,
      },
    })
    this.isLoading = false
  }

  private async checkServices2(item: {
    id: number
    service: {
      id: number
      active: boolean
    }
  }) {
    this.isLoading = true
    await this.$axios.$post(API_CART_SERVICE, {
      id: item.id,
      service: item.service,
    })

    await this.cartGetItems()

    this.isLoading = false
  }

  private get activeCartServiceItems() {
    let services: IProductAdditionalService[] = []

    this.activeCartItems.forEach((item) => {
      if (item.services && item.services.length > 0) {
        const services2 = item.services.filter((item2) => item2.active)
        if (services2.length > 0) {
          services = services.concat(services2)
        }
      }
    })
    return services
  }

  private get activeServiceItemsQuantity() {
    return this.activeCartServiceItems.length
  }
}
